import React from 'react'


export default function Search({onSearch}) {
  return (
    <div>
         
                            
                             <form className='search-form' onSubmit={(e) => { e.preventDefault()}}>
                             <input
                                   type="text"
                                   placeholder="Ismi bo'yicha qidirish"
                                   onChange={(e) => onSearch(e.target.value)}
                              />
                               </form>
                    

    </div>
  )
}
